<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_1"></a><a id="page_2"></a><a id="page_3">A GARDEN OF PRAYER</a></h1><a id="page_3">
<h2 class="titlea">A Family Treasury</h2>
<p class="author">Jenna Bassin and Jane Lahr</p>
<p class="centerimg"><img alt="image" src="images/PhilosophicalLibrary-Sw_fmt.jpg"/></p>
<p class="centerimg"><img alt="image" src="images/logo.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?40a61718